function fmtPrice(v) {
  if (v == null) return '—';
  return `$${Number(v).toFixed(2)}`;
}

function fmtChange(v) {
  if (v == null) return '—';
  const sign = v >= 0 ? '+' : '';
  return `${sign}${v.toFixed(2)}`;
}

function fmtChangePct(v) {
  if (v == null) return '';
  const sign = v >= 0 ? '+' : '';
  return `${sign}${v.toFixed(2)}%`;
}

export default function QuoteCard({ quote, isSelected, onSelect }) {
  const { ticker, price, change, change_percent, high_52w, low_52w } = quote || {};

  // Slider position: where the current price sits between low_52w and high_52w
  let pct = 50;
  if (price != null && low_52w != null && high_52w != null && high_52w > low_52w) {
    pct = Math.max(0, Math.min(100, ((price - low_52w) / (high_52w - low_52w)) * 100));
  }

  const isUp = (change ?? 0) >= 0;
  const changeColor = isUp ? 'text-green-400' : 'text-red-400';

  return (
    <button
      type="button"
      onClick={() => onSelect?.(ticker)}
      className={`text-left w-full bg-gray-900/60 rounded-xl p-3 transition-all border ${
        isSelected ? 'border-blue-500 shadow-[0_0_0_1px_rgba(59,130,246,0.4)]' : 'border-gray-700/50'
      } active:scale-[0.98]`}
    >
      <div className="flex justify-between items-start">
        <span className="text-white font-bold text-sm">{ticker}</span>
        <span className="text-white font-semibold text-sm">{fmtPrice(price)}</span>
      </div>

      <div className="flex justify-between items-center mt-2">
        <span className="text-gray-400 text-[10px] uppercase tracking-wider">52W</span>
        <span className={`${changeColor} text-[11px] font-semibold`}>
          {fmtChange(change)} ({fmtChangePct(change_percent)})
        </span>
      </div>

      <div className="relative mt-2 h-1.5 rounded-full bg-gray-700/70 overflow-visible">
        <div
          className="absolute -top-[3px] w-3 h-3 rounded-full bg-blue-500 shadow-md"
          style={{ left: `calc(${pct}% - 6px)` }}
        />
      </div>

      <div className="flex justify-between mt-1.5">
        <span className="text-gray-500 text-[10px]">Lo: ${low_52w != null ? Math.round(low_52w) : '—'}</span>
        <span className="text-gray-500 text-[10px]">Hi: ${high_52w != null ? Math.round(high_52w) : '—'}</span>
      </div>
    </button>
  );
}
